var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLinkedin18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "url(#pattern0_30_65)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_30_65",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_30_65",
    transform: "translate(-0.00295858) scale(0.00591716)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_30_65",
    width: 170,
    height: 169,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKoAAACpCAMAAACMPFYeAAAAM1BMVEVHcExyc3Nyc3Nyc3Nyc3Nyc3Nyc3Nyc3Nyc3Nyc3Nyc3Nyc3Nyc3Nyc3Nyc3Nyc3Nyc3O03Q0PAAAAEHRSTlMAINBgQKDwgMAQ4DCQcFCwuRZh2wAAAAlwSFlzAAALEgAACxIB0t1+/AAAA0hJREFUeJztm9mSozAMRVmMbbbE//+1U9NJd5YrGxGCEFU6r1jJKfAuu3qlb7voU0qpicFVimmv6Rk/1UpdL0MCuh6KHU8fwfM/vlVnOnqwvKPtxbZg+KBR5Voy1eWa//r3OgARR9ETTf+VWYvqBGrveCUd7AhmSISoQ6A71DdUjLI1aFGoaFnLNfUHDR3WYvO/oWCA5X1/FTWgPFA9GCBSnABSGY5X7WgxZIRQaVi9alLRs5rqHrDr6vEzlhP1ABdwomkgUpwTjVZVA1YkFwiUZ6bEAK9hZnWi+Sqvu9KxuOK8Vi3L6+WuVUVN/WGxE9DQ/G/UC7srE0QcR3knSM8+ULXgqsu0qsZsfQ1Q9mh6ej9gUJm8GHGW7fW90jtj91Jlm1Zj0uIPF7oY0xDj1GrNBBmGYRiGYYjg2jDFO10IF6dyFle3HZUs8zFcVPnWc3Zp9DNHDsX0CJRH6NUALhveeY9wVygCNHP+3UJh5Duqjpl48CEnC0WRb6jW7AxJflEHBRE6cpUqO+lwg14qQzFks2p+nyEL9Z+5sk9QYWtU28LuTZaINTZX9HuqKz/+L3jAC4og21TZabxFVyiBbFL92BRdoQCyRZXeDGMSJVW5xzgyTHKqnANnRZyU6vJ5wyWGXkh1U0XF/4aHyKeqmz9/ek3vwTPkU9X1wylBJ6L6HerzqHbnUX3kTeERcqzq4+wkPEEOVm3Oo/rXsOABcrTqfB7VeB7VdCJVdx7VcB7VKK7q4xRa51wI15UTWVnVYX7Z5avDGttaUDUSOzsrdjIuYqqevgeVuZFIEKRUm+wGL3eToBNShV2S9T8SZVSLN8uYa1ovo0o0qCcclCcRUV06U8b7mVpAdfGYJu+1OgFVOvYZVm2VUC21qRus497t/qpXCANYezBhf1XOTT1ODRBQ5aRNGTlCAVXWhRJOWmPaXZV1+JnTXcXdVVmXSjnn/fdXLQ+qv0AYsr8qBJEwugAtqoxf2l2VeVvfVPdQZSRidlelAwHGGGCqpmqqxUDAVE3VVE21iKmaqqkWAwFTNVVTNdUipmqqploMBEzVVE3VVIuYqqmaajEQMFVTNVVTLWKqpmqqxUDAVE3VVE21iKmaqql+WTWl+A//Gnbi2Ew/dwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLinkedin18);
export default __webpack_public_path__ + "static/media/Logo_Linkedin_1-8.50433733a153b89ac79a84292010f62d.svg";
export { ForwardRef as ReactComponent };